// extracted by mini-css-extract-plugin
export default {"productGrid":"hZ-z","centerLink":"iZ-z","productSection":"jZ-z","item":"kZ-z","ctaButton":"lZ-z"};